import { render, staticRenderFns } from "./CheckoutMaterialsDownload.vue?vue&type=template&id=babd86cc"
import script from "./CheckoutMaterialsDownload.vue?vue&type=script&lang=ts"
export * from "./CheckoutMaterialsDownload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports